<!---->
<template>
<div class="left-box">
  <div class="im-left-nav" id="im-left-nav">
    <div class="functional_module">
      <div class="m-l-5 t-a-center f-s-12" :class="{active:item.apiKey == selectedTab}" v-for="(item,index) in functionalArr" :key="index" @click="activeTab(item)" @dblclick="doubleClick(item)">
        <div class="icon">
          <img v-if="item.apiKey == selectedTab" :src="item.activeIcon"/>
          <img v-else :src="item.unActiveIcon"/>
        </div>
        <div class="text m-t-2">
          {{item.text}}
        </div>
        <span v-show="unreadCountCp.count!=0 && item.apiKey == 'message'" class="unread-count-cp">{{unreadCountCp.count}}</span>
        <span class="unread-count-cp-mute" style="top: 0px; right: 6px; background-color: #EC5943;" v-show="unreadCountCp.mute && item.apiKey == 'message'">&nbsp;</span>
        <span class="unread-count-cp-mute" style="top: 0px; right: 6px; background-color: #EC5943;" v-show="notificationList.total > 0 && item.apiKey == 'notification' && showNotificationFlag !== 'false'">&nbsp;</span>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
export default {
  data() {
    return {
      functionalArr:[
        {
          text:"消息",
          unActiveIcon: require("@/assets/images/im/icon_news@2x.png"),
          activeIcon: require("@/assets/images/im/icon_news_active@2x.png"),
          apiKey: "message"
        },
        {
          text:"通讯录",
          unActiveIcon: require("@/assets/images/im/icon_address_book@2x.png"),
          activeIcon: require("@/assets/images/im/icon_address_book_active@2x.png"),
          apiKey: "contact"
        },
        {
          text:"系统通知",
          unActiveIcon: require("@/assets/images/im/xttzgrey.png"),
          activeIcon: require("@/assets/images/im/xttz.png"),
          apiKey: "notification"
        },
      ],
      selectedTab: "message",
      changeGroupVisible: false,
      activeSetting: false,
      activeLogout: false,
      showNotificationFlag: localStorage.getItem('show-notification-flag'), // 显示系统通知的小红点
    };
  },
  props:{
    unreadCountCp:{
      type:Object,
      default:{}
    },
    myAccountData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initSelectedLeftTabFlag: {
      type: String,
      default: ''
    },
    notificationList: {
      type: Object
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.onDragByMousedown();
    this.bus.$on("selectNewsTab",()=>{
      this.activeTab(this.functionalArr[0]);
    })
    this.bus.$on("closeSetting",()=>{
      this.activeSetting = false;
    })
    
  },
  methods: {
    activeTab(item){
      this.selectedTab = item.apiKey;
      this.$root.$children[0].activeTab = item.apiKey;
      if(this.selectedTab === 'message') {
        this.$emit("transferSelectedTab", '0');
      }
      if(this.selectedTab === 'contact') {
        this.$emit("transferSelectedTab", '1')
      }
      if(this.selectedTab === 'notification') {
        this.showNotificationFlag = 'false';
        localStorage.setItem('show-notification-flag', false)
        this.$emit("transferSelectedTab", '2')
      }
    },
    doubleClick(item){
      if(item.apiKey == "message"){
        this.bus.$emit("msgOnDoubleClick")
      }
    },
    handelSet(){
      this.activeSetting = true;
      this.bus.$emit("showSetting")
    },
    getJumpUrl(){
      let urlObj = {
        localhost:"http://localhost:8081",
        test:"https://kh-test.yto56test.com",
        pre:"https://khsd.yto.net.cn:1443",
        prod:"https://kh.yto.net.cn"
      };
      return urlObj[window.env];
    },
    logout() {
      this.activeLogout = true;
      this.$confirm('确认退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.bus.$emit('logout');
        }).catch(() => {
      this.activeLogout = false;
                   
        });
    },
    onDragByMousedown(){
      let vm = this;
      setTimeout(()=>{
        let $imleftnav = document.getElementById("im-left-nav");
        $imleftnav.addEventListener("mousedown",function(e){
          const {target} = e;
          const appRegion = getComputedStyle(target)['-webkit-app-region'];
          if(appRegion == 'drag'){
            vm.onDrag(e)
          }
        });
        $imleftnav.removeEventListener("mouseup",function(e){
          vm.onDrag(e)
        })
      },0)
    },
    onDrag(e){
      e.preventDefault();
      e.stopPropagation();
      // formHandler 由桌面客户端注入，浏览器环境下不存在
      window.formHandler && formHandler.Move()
    },
    getTokenByYuanJie(mobile) {
      axiosHttpIm.post('/yuanjie/getTokenYuanJie', {}, {
        headers: {
          'jwt-token':window.im_store_const.token
        }
      }).then((res) => {
        let url = res.data || '';
        if(url){
          sysHandler.OpenFile(url);
        }
      });
    },
    // 获取cookie
    getCookie: function (name) {
      var strcookie = document.cookie;//获取cookie字符串
      var arrcookie = strcookie.split("; ");//分割
      //遍历匹配
      for ( var i = 0; i < arrcookie.length; i++) {
          var arr = arrcookie[i].split("=");
          if (arr[0] == name){
              return arr[1];
          }
      }
      return "";
    },
  },
  watch:{
    initSelectedLeftTabFlag(newVal){
      console.log("newVal",newVal)
      if(newVal == 'true'){
        console.log("初始化");
        this.activeTab(this.functionalArr[0])
      }
    }
  }
};
</script>

<style lang='scss' scoped='' type='text/css'>
.left-box{
  position: relative;
  background: #eee;
}
.im-left-nav {
  width: 60px;
  height: 100%;
  background: #eee;
  -webkit-app-region: drag;
  .organization {
    text-align: center;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
      margin-top: 11px;
      // margin: 10px auto 5px 5px;
    }
    .switch-icon{
      position: absolute;
      width: 7px;
      height: 4px;
      left: 43px;
      top: 10px;
    }
    .user-name{
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      padding: 0 4px;
      text-align: center;
    }
  }
  .functional_module{
    &>div{
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 50px;
      height: 50px;
      color: #333333;
      margin-top: 8px;
      cursor: pointer;
      &:first-of-type{
        margin-top: 16px;
      }
      // &:last-of-type{
      //   position: absolute;
      //   bottom: 14px;
      // }
      .icon{
        img{
          width: 21px;
          height: 21px;
        }
      }
      .unread-count-cp{
        position: absolute;
        top: -10px;
        right: -4px;
        font-size: 12px;
        background: #EC5943;
        border-radius: 8px;
        color: #fff;
        line-height: 16px;
        padding: 0 5px 1px 5px;
      }
      .unread-count-cp-mute{
        position: absolute;
        top: -2px;
        right: -4px;
        width: 10px;
        height: 10px;
        font-size: 12px;
        background: #EC5943;
        border-radius: 50%;
      }
    }
    .active{
      background: #DDDEDF;
      border-radius: 10px;
      .text{
        color: #653EB3;
      }
    }
    
  }
}
</style>
